import { CHANGELOG } from '../changelog.js';

export function ChangelogModal({darkMode, onClose}) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50" onClick={onClose}>
      <div onClick={(e) => e.stopPropagation()}
        className={`w-full max-w-md max-h-[80vh] overflow-y-auto rounded-2xl shadow-xl p-6 ${
          darkMode ? 'bg-gray-800 border border-gray-700' : 'bg-white'
        }`}>
        <div className="flex items-center justify-between gap-3 mb-4">
          <h2 className={`text-xl font-bold ${darkMode ? 'text-white' : 'text-gray-800'}`}>
            What's New
          </h2>
          <button onClick={onClose}
            className={`flex-shrink-0 px-3 py-1.5 rounded-lg text-sm font-semibold transition ${
              darkMode ? 'bg-gray-700 hover:bg-gray-600 text-gray-200' : 'bg-gray-100 hover:bg-gray-200 text-gray-700'
            }`}>
            Got it
          </button>
        </div>
        <div className="space-y-5">
          {CHANGELOG.map(entry => (
            <div key={entry.version}>
              <h3 className={`font-semibold mb-2 ${darkMode ? 'text-indigo-300' : 'text-indigo-700'}`}>
                Version {entry.version}
              </h3>
              {/* A version is either sectioned ({title, items} groups) or a
                  plain list; a plain one renders as a single untitled group. */}
              <div className="space-y-3">
                {(entry.sections || [{ title: null, items: entry.items }]).map(section => (
                  <div key={section.title || 'all'}>
                    {section.title && (
                      <h4 className={`text-xs font-semibold uppercase tracking-wide mb-1 ${darkMode ? 'text-gray-400' : 'text-gray-500'}`}>
                        {section.title}
                      </h4>
                    )}
                    <ul className={`list-disc list-outside pl-5 space-y-1 text-sm ${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>
                      {section.items.map((item, i) => (<li key={i}>{item}</li>))}
                    </ul>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
        <button onClick={onClose}
          className="w-full mt-6 bg-indigo-600 hover:bg-indigo-700 text-white font-semibold py-3 rounded-lg transition">
          Got it
        </button>
      </div>
    </div>
  );
}
